var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgViewArchive = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  fillRule: "evenodd",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M2 1.25A1.75 1.75 0 0 0 .25 3v3h1v7c0 .966.784 1.75 1.75 1.75h10A1.75 1.75 0 0 0 14.75 13V6h1V3A1.75 1.75 0 0 0 14 1.25zM14.25 4.5V3a.25.25 0 0 0-.25-.25H2a.25.25 0 0 0-.25.25v1.5zM2.75 6v7c0 .138.112.25.25.25h10a.25.25 0 0 0 .25-.25V6z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgViewArchive);
export default ForwardRef;